import Filter from "../models/filter";
import httpService from "./httpService";
import { SummaryChartDataItem } from "../models/summaryChartDataItem";
import { Chart } from "../models/chart";

const apiEndpoint = "/charts";

const getSummaryChartDataItems = (
  idThematicMapLayer: number,
  filters: Filter[],
) => {
  return httpService.post<SummaryChartDataItem[]>(
    `${apiEndpoint}/getSummaryChartDataItems`,
    { idThematicMapLayer, filters },
  );
};

const getCharts = (idProject: number) => {
  return httpService.get<Chart[]>(
    `${apiEndpoint}/getCharts?idProject=${idProject}`,
  );
};

const createChart = (chart: Chart) => {
  return httpService.post(`${apiEndpoint}/createChart`, chart);
};

const updateChart = (chart: Chart) => {
  return httpService.post(`${apiEndpoint}/updateChart`, chart);
};

const deleteChart = (idChart: number) => {
  var data = new FormData();
  data.append("idChart", idChart.toString());
  return httpService.post(`${apiEndpoint}/deleteChart`, data);
};

const updateChartVisibility = (idChart: number, isVisible: boolean) => {
  var data = new FormData();
  data.append("idChart", idChart.toString());
  data.append("isVisible", isVisible.toString());
  return httpService.post(`${apiEndpoint}/updateChartVisibility`, data);
};

const chartService = {
  getSummaryChartDataItems,
  getCharts,
  createChart,
  updateChart,
  deleteChart,
  updateChartVisibility,
};

export default chartService;
